module.exports = __webpack_public_path__ + "img/Paginasamarillas.com.do.03c85816.svg";